import { render, staticRenderFns } from "./SliderFlux.vue?vue&type=template&id=2e6fdfec&scoped=true"
import script from "./SliderFlux.vue?vue&type=script&lang=js"
export * from "./SliderFlux.vue?vue&type=script&lang=js"
import style0 from "./SliderFlux.vue?vue&type=style&index=0&id=2e6fdfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6fdfec",
  null
  
)

export default component.exports